import { render, staticRenderFns } from "./PreviewGenreAdd.vue?vue&type=template&id=5e2ab98e&lang=pug"
import script from "./PreviewGenreAdd.vue?vue&type=script&lang=js"
export * from "./PreviewGenreAdd.vue?vue&type=script&lang=js"
import style0 from "./PreviewGenreAdd.vue?vue&type=style&index=0&id=5e2ab98e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports